import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { DateFnsModule } from '@angular/material-date-fns-adapter';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TM_SHARED_UI_PROVIDERS, TmSharedUIModule } from '@teammood/shared/ui';
import { GlobalErrorHandler } from '@teammood/shared/util/core';
import { HTTP_INTERCEPTORS } from '@teammood/shared/util/http';
import { TmTranslateHttpLoader } from '@teammood/shared/util/i18n';
import { TM_DATE_LOCALE_PROVIDERS } from '@teammood/shared/util/locale';
import { TmAdminModule } from '../lib/admin/admin.module';
import { TmSetupModule } from '../lib/setup/setup.module';
import { TmPollSetupModule } from '../lib/polls/polls.module';
import { TmAuthModule } from "../lib/auth/auth.module";
import { TmErrorMessageModule } from "../lib/error-message/error-message.module";
import { TmExportsModule } from "../lib/exports/exports.module";
import { TmApiKeysModule } from "../lib/api-keys/api-keys.module";
import { TmBillingModule } from "../lib/billing/billing.module";
import { TmTroubleshootModule } from "../lib/troubleshoot/troubleshoot.module";
import { TmOnboardingModule } from '../lib/onboarding/onboarding.module';
import { TmOrganizationModule } from "../lib/organization/organization.module";
import { TmAddFeedbackModule } from "../lib/add-feedback/add-feedback.module";
import { TmCalendarModule } from '../lib/calendar/calendar.module';
import { TmReportingModule } from '../lib/reporting/reporting.module';
import { TmAnalyticsModule } from '../lib/analytics/analytics.module';
import { TmTimelineModule } from "../lib/timeline/timeline.module";
import { TmTaskbookModule } from '../lib/taskbook-triage/taskbook-triage.module';
import { RouterModule } from "@angular/router";
import { APP_ROUTES } from "./app.routes";
import { TmTaskbookBacklogModule } from '../lib/taskbook-backlog/taskbook-backlog.module';
import { provideHighcharts } from 'highcharts-angular';


@NgModule({ declarations: [], imports: [BrowserAnimationsModule,
        BrowserModule,
        DateFnsModule,
        LoadingBarHttpClientModule,
        LoadingBarModule,
        MatSnackBarModule,
        TmAdminModule,
        TmOnboardingModule,
        TmSetupModule,
        TmPollSetupModule,
        TmSharedUIModule,
        TmAuthModule,
        TmErrorMessageModule,
        TmExportsModule,
        TmApiKeysModule,
        TmBillingModule,
        TmTroubleshootModule,
        TmOrganizationModule,
        TmAddFeedbackModule,
        TmTaskbookModule,
        TmTaskbookBacklogModule,
        TmCalendarModule,
        TmReportingModule,
        TmAnalyticsModule,
        TmTimelineModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useClass: TmTranslateHttpLoader,
            }
        }),
        RouterModule.forRoot(APP_ROUTES, {
            useHash: true,
        })], providers: [
        provideHttpClient(withXhr(), withInterceptors(HTTP_INTERCEPTORS)),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        ...TM_DATE_LOCALE_PROVIDERS,
        ...TM_SHARED_UI_PROVIDERS,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideHighcharts({
                instance: () => import('highcharts/esm/highcharts').then(m => m.default),
                modules: () => {
                        return [
                                import('highcharts/esm/highcharts-more'),
                                import('highcharts/esm/modules/accessibility'),
                                import('highcharts/esm/modules/wordcloud'),
                        ];
                },
        }),
    ] })
export class AppModule {
}
